import ReactDOM from 'react-dom'
import { ZoomMtg } from '@zoom/meetingsdk'
import MeetingData from '../components/MeetingData'
import { waitForElement, toggleAudio, toggleVideo } from '../utils/zoom-utils'

export const setupCustomUI = (
  brand: string,
  startDate: string,
  endDate: string,
  language: string,
  token: string,
) => {
  waitForElement('.preview-agreement').then((element: any) => {
    if (element) {
      ReactDOM.render(
        <MeetingData
          brand={brand}
          startDate={startDate}
          endDate={endDate}
          language={language}
          token={token}
        />,
        element,
      )
    }
  })

  waitForElement('.preview-new-flow-content.vertical-container').then(
    (element: any) => {
      const previewNewFlowContent = element as HTMLElement
      previewNewFlowContent.classList.replace(
        'vertical-container',
        'horizontal-container',
      )
    },
  )

  let newFlexColDiv: HTMLDivElement | null = null

  waitForElement('.preview-new-flow-content.horizontal-container').then(
    (element: any) => {
      const previewNewFlowContent = element as HTMLElement

      newFlexColDiv = document.createElement('div')
      newFlexColDiv.style.display = 'flex'
      newFlexColDiv.style.flexDirection = 'column'
      newFlexColDiv.style.justifyContent = 'center'
      newFlexColDiv.style.alignItems = 'center'

      previewNewFlowContent.appendChild(newFlexColDiv)

      waitForElement('.preview-agreement').then((agreementElement: any) => {
        if (newFlexColDiv) {
          newFlexColDiv.appendChild(agreementElement)
        }
      })

      waitForElement(
        '.zm-btn.preview-join-button.zm-btn--default.zm-btn__outline--blue',
      ).then((buttonElement: any) => {
        if (newFlexColDiv) {
          newFlexColDiv.appendChild(buttonElement)
          buttonElement.style.width = '100%'
        }
      })

      waitForElement('.preview-join-button').then((joinButtonElement: any) => {
        if (newFlexColDiv) {
          newFlexColDiv.appendChild(joinButtonElement)
          joinButtonElement.style.width = '99px'
          joinButtonElement.style.height = '48px'
          joinButtonElement.style.minWidth = '96px'
          joinButtonElement.textContent =
            language === 'ca' ? 'UNIR-SE' : 'UNIRSE'

          joinButtonElement.style.backgroundColor =
            brand === 'vidacaixa' ? '#007EAE' : '#004039'

          joinButtonElement.addEventListener('mouseover', () => {
            joinButtonElement.style.backgroundColor =
              brand === 'vidacaixa' ? '#036085' : '#336661'
          })
          joinButtonElement.addEventListener('mouseout', () => {
            joinButtonElement.style.backgroundColor =
              brand === 'vidacaixa' ? '#007EAE' : '#004039'
          })

          joinButtonElement.addEventListener('focus', () => {
            joinButtonElement.style.backgroundColor =
              brand === 'vidacaixa' ? '#007EAE' : '#004039'
            joinButtonElement.style.border =
              brand === 'vidacaixa' ? '4px solid #cce5f0' : '4px solid #8AA7A4'
          })
        }
      })
    },
  )

  setupAudioVideoControls()
  setupMoreButton()
}

const setupAudioVideoControls = () => {
  waitForElement('.zm-btn.preview-mic-toggle-btn').then((element: any) => {
    const micToggleBtn = element as HTMLElement
    if (localStorage.getItem('zoom_audio_enabled') === null) {
      const isActive = !micToggleBtn.classList.contains('zm-btn-toggle--off')
      localStorage.setItem('zoom_audio_enabled', isActive.toString())
    }

    micToggleBtn.addEventListener('click', () => {
      toggleAudio()
    })
  })

  waitForElement('.zm-btn.preview-video-toggle-btn').then((element: any) => {
    const videoToggleBtn = element as HTMLElement
    if (localStorage.getItem('zoom_video_enabled') === null) {
      const isActive = !videoToggleBtn.classList.contains('zm-btn-toggle--off')
      localStorage.setItem('zoom_video_enabled', isActive.toString())
    }

    videoToggleBtn.addEventListener('click', () => {
      toggleVideo()
    })
  })
}

let micInstructionsShown = false

export const showParticipantMicInstructions = (language = 'es') => {
  if (micInstructionsShown) {
    return
  }

  micInstructionsShown = true

  waitForElement('div[footer-section="lef"]').then((element: any) => {
    document
      .querySelectorAll('.footer-button__wrapper.mic-instructions')
      .forEach((el) => el.remove())

    const footerElement = element as HTMLElement
    const customDiv = document.createElement('div')
    customDiv.className = 'footer-button__wrapper mic-instructions'

    const message =
      language === 'ca'
        ? 'Silenciat. Toca 🎙️ per activar'
        : 'Silenciado. Toca 🎙️ para activar'

    customDiv.innerHTML = `<span style="color: black; font-size: 14px; margin: 0 10px; display: flex; align-items: center; justify-content: center; font-weight: bold; height: 100%; width: 100%; background-color: #01ff91; padding: 8px; border-radius: 4px;">${message}</span>`

    customDiv.style.opacity = '0'
    customDiv.style.transition = 'opacity 0.5s ease-in, opacity 1s ease-out'

    const existingControls = footerElement.querySelectorAll(
      '.footer-button__wrapper:not(.mic-instructions)',
    )
    if (existingControls.length >= 2) {
      footerElement.insertBefore(customDiv, existingControls[1].nextSibling)
    } else {
      footerElement.appendChild(customDiv)
    }

    setTimeout(() => {
      customDiv.style.opacity = '1'
    }, 50)

    setTimeout(() => {
      customDiv.style.opacity = '0'
      setTimeout(() => {
        customDiv.style.display = 'none'
        setTimeout(() => {
          micInstructionsShown = false
        }, 10000)
      }, 500)
    }, 5000)
  })
}

export const applyVirtualBackground = (brand: string) => {
  ZoomMtg.updateVirtualBackgroundList({
    vbList: [
      {
        id: 'vcxBg',
        fileName: 'vcxBg.png',
        displayName: 'VCX BG',
        url: `${window.location.origin}/assets/images/zoom/vcxBg.png`,
      },
      {
        id: 'qidaBg',
        fileName: 'qidaBg.png',
        displayName: 'QIDA BG',
        url: `${window.location.origin}/assets/images/zoom/qidaBg.png`,
      },
      {
        id: 'noLogoBg',
        fileName: 'noLogoBg.png',
        displayName: 'No Logo BG',
        url: `${window.location.origin}/assets/images/zoom/noLogoBg.png`,
      },
    ],
    success: function () {
      ZoomMtg.setVirtualBackground({
        id:
          brand === 'vidacaixa'
            ? 'vcxBg'
            : brand === 'qida'
              ? 'qidaBg'
              : 'noLogoBg',
        success: function () {
          console.log('Virtual Background applied successfully immediately.')
        },
        error: function (err: unknown) {
          console.error('Error setting Virtual Background immediately:', err)
        },
      })
    },
  })
}

export const handleJoinSuccess = (
  role: number,
  brand: string,
  language: string,
) => {
  try {
    const audioEnabled = localStorage.getItem('zoom_audio_enabled') === 'true'

    if (audioEnabled) {
      try {
        ZoomMtg.mute({
          mute: false,
          userId: 0,
        })
      } catch (error) {
        console.error('Failed to unmute audio:', error)
      }
    }

    if (role === 0) {
      showParticipantMicInstructions(language)
    }

    if (role === 1) {
      applyVirtualBackground(brand)
    }
  } catch (error) {
    console.error(
      'Error al intentar aplicar fondo virtual inmediatamente:',
      error,
    )
  }
}
const setupMoreButton = () => {
  const isMobile =
    /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ||
    window.innerWidth < 768

  if (!isMobile) {
    waitForElement('div[feature-type="more"]').then((element: any) => {
      const moreButton = element as HTMLElement
      moreButton.style.display = 'none'
    })
  } else {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach((node) => {
            if (
              node instanceof HTMLElement &&
              (node.classList.contains('dropdown-menu') ||
                node.classList.contains('more-button__pop-menu'))
            ) {
              node.style.visibility = 'hidden'

              const menuItems = node.querySelectorAll('.more-button__item-box')
              let chatItemFound = false

              menuItems.forEach((item: any) => {
                item.style.display = 'none'
              })

              menuItems.forEach((item: any) => {
                const chatIcon = item.querySelector('svg.SvgChat')
                const chatText =
                  item.textContent && item.textContent.includes('Chat')

                if (chatIcon || chatText) {
                  item.style.display = 'block'
                  chatItemFound = true
                }
              })

              node
                .querySelectorAll('.common-ui-component__dropdown-divider2')
                .forEach((element: any) => {
                  element.style.display = 'none'
                })

              if (!chatItemFound) {
                console.log('No se encontró el elemento de chat en el menú.')
              }

              setTimeout(() => {
                node.style.visibility = 'visible'
              }, 10)
            }
          })
        }
      })
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })

    waitForElement('button[aria-label="More meeting control"]').then(
      (button: any) => {
        button.style.display = 'block'
      },
    )
  }
}
